import Api from './Api';
class PecasApi extends Api {
    async recuperarPecasPorProcesso(idSessaoJulgamento, numeroProcesso) {
        let result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/documentos'
        );
        return result.data;
    }
}

export default PecasApi;
